import { render, staticRenderFns } from "./SoundSwitch.vue?vue&type=template&id=04e69cfa&"
import script from "./SoundSwitch.vue?vue&type=script&lang=ts&"
export * from "./SoundSwitch.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports